export default "/profile/images/instruction-4-ua.webp?a8547c09ae476e7e5dabdd8dfda3e22a";